import { useState } from "react";
import { KeyedMutator } from "swr";

import { Box, Button, Flex, FormDialog, Typography } from "flux";

import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
import uploadAdAssetImage from "../../utils/upload-ad-asset-image";
import { AdAsset } from "../../types/ad-asset";

interface ImageUploadDialogProps extends BaseDialogProps {
  brandId?: string;
  imageId: number;
  refetchAdAssets: KeyedMutator<AdAsset[]>;
}

function ImageUploadDialog(props: ImageUploadDialogProps) {
  const { onClose, brandId, imageId, refetchAdAssets } = props;
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!brandId) return;
    if (!file) return;
    setUploading(true);
    try {
      await uploadAdAssetImage(file, brandId, imageId);
    } catch (error) {
      console.error("Error editing ad asset image", error);
    } finally {
      refetchAdAssets();
      setUploading(false);
      onClose(true);
    }
  };

  return (
    <FormDialog
      {...props}
      onSubmit={handleSubmit}
      primaryButtonText="Submit"
      title="Replace Ad Asset Image"
      isPrimaryButtonDisabled={uploading || !file}
      dataDogIdentifier="replace ad asset image"
    >
      <Flex sx={{ width: "100%" }} pb="24px">
        <Box>
          <input type="file" onChange={handleFileChange} style={{ display: "none" }} id="file-upload-input" />
          <label htmlFor="file-upload-input">
            <Button variant="contained" component="span" dataDogIdentifier="replace ad asset image upload file">
              Upload File
            </Button>
          </label>
          {file && (
            <Typography variant="body2" mt={1}>
              Selected file: {file.name}
            </Typography>
          )}
        </Box>
      </Flex>
    </FormDialog>
  );
}

export default ImageUploadDialog;
